import React from "react";
import ReactDOM from "react-dom";
// import "./index.css";
import "./styles/tailwind.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./store";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from "@posthog/react";

const options = {
  api_host: "https://us.i.posthog.com",
  defaults: "2026-01-30",
  disabled: process.env.REACT_APP_POSTHOG_KEY ? false : true,
  debug: process.env.REACT_APP_ENVIRONMENT === "development",
};

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  environment: process.env.REACT_APP_ENVIRONMENT,
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/.*\.akutehealth\.com/],
  // Enable logs to be sent to Sentry
  enableLogs: true,
});

ReactDOM.render(
  <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY} options={options}>
    <Provider store={store}>
      <App />
    </Provider>
  </PostHogProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
